import InternetAndMobileOffersPage from "./InternetAndMobileOffersPage.vue";

const root = document.getElementById("internet-and-mobile-offers");

const app = new Vue({
    el: '#internet-and-mobile-offers',
    components: {InternetAndMobileOffers: InternetAndMobileOffersPage},
    data: {
        dto: internetAndMobileOffersDto,
        token: root.dataset.token
    },
});
